<script setup lang="ts">
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { Issue, IssueLabel, User } from '@/generated/graphql'
import IconIssue from '@/components/icons/IconIssue.vue'
import AssociatedIssuesTable from '@/components/issue/AssociatedIssuesTable.vue'
import { CreateIssueSeed } from '@/components/issue/CreateIssueDialog.vue'

type LocalUser = Pick<User, 'id' | 'firstname' | 'lastname'>
type LocalLabel = Pick<IssueLabel, 'id' | 'name' | 'color'>
type LocalIssue = Pick<Issue, 'id' | 'name' | 'createdAt' | 'resolvedAt'> & {
  assignedToUsers: LocalUser[]
  labels: LocalLabel[]
}
type LocalLink = { issue: LocalIssue }

defineProps<{
  links: LocalLink[]
  createSeed?: CreateIssueSeed
}>()

const { t } = useI18n()
const open = ref(false)
</script>

<template>
  <template v-if="links.length > 0">
    <v-badge :content="links.length" color="error">
      <v-btn icon variant="text" density="comfortable" @click="open = true">
        <icon-issue />
      </v-btn>
    </v-badge>
    <v-dialog v-model="open" max-width="800">
      <v-card>
        <v-card-title>{{ t('entity.issue.plural') }}</v-card-title>
        <v-card-text>
          <associated-issues-table :links="links" :create-seed="createSeed" />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn @click="open = false">{{ t('button.close') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </template>
</template>
